module.exports = __webpack_public_path__ + "45d54802cde85d0660b36cee38062f55.jpg";